import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { canvasService } from '../../apiServices/CanvasService';
import { defaultUser } from '../../stubs';
import { UserContext, UserData } from './useUser';

// Exposing data through the UserContext to simplify underlying child components
export const ExportUserProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [userData, setUserData] = useState<UserData>(defaultUser);
  const [isAuthenticated] = useState(true);

  const setIsAuthenticated = () => {};
  const signOut = () => {};
  const fetchUser = () => {};

  const location = useLocation();
  const { pathname, search } = location;
  const isExportRoute = pathname.includes('/projects/export');

  const canvasId = pathname.split('/')[3];
  useEffect(() => {
    if (!isExportRoute) return;

    const urlParams = new URLSearchParams(search);
    const token = urlParams.get('token');

    canvasService.getExportCanvas(canvasId, token).then((canvases) => {
      setUserData({ ...userData, canvases });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <UserContext.Provider
      value={{
        ...userData,
        isAuthenticated,
        setIsAuthenticated,
        signOut,
        fetchUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
